class AdminHotKey {
  constructor() {
    this.isSearchExists();
    this.key_press();
  }

  isSearchExists() {
    return $('.admin-search-page').length > 0;
  }

  open_search() {
    document.querySelector('#search_view').click();
  }

  remove_search_page() {
    document.querySelector('.admin-search-page').remove();
  }

  focus_on_str_search() {
    document.querySelector('#search_query').focus();
  }

  open_search_panel() {
    if($('#search_view').length === 0) return;
    if(!this.isSearchExists()) return this.open_search();
    this.focus_on_str_search();
  }

  close_search_panel() {
    if(this. isSearchExists()) return this.remove_search_page();
  }

  key_up() {
    let selectedItem = $('#selected_search_result_item'); 
    selectedItem.length > 0 ? this.move_up(selectedItem) : "";
  }

  key_down() {
    let selectedItem = $('#selected_search_result_item');
    selectedItem.length > 0 ? this.move_down(selectedItem) : "";
  }

  move_up(item) {
    if($("#selected_search_result_item").prev().length !== 0) {
      item.prev().attr("id","selected_search_result_item");
      item.removeAttr("id","selected_search_result_item");
    }
    $("#selected_search_result_item").focus();
    document.getElementById("selected_search_result_item").scrollIntoView({block: "start", behavior: "smooth"});
  }

  move_down(item) {
    if($("#selected_search_result_item").next().length !== 0) {
      item.next().attr("id","selected_search_result_item");
      item.removeAttr("id","selected_search_result_item");
    }
    $("#selected_search_result_item").focus();
    document.getElementById("selected_search_result_item").scrollIntoView({block: "end", behavior: "smooth"});
  }

  obj_actions() {
    let self = this;
    this.actions = {
      38: function() {
        self.key_up();
      }, 
      40: function() {
        self.key_down();
      },
      27: function() {
        self.close_search_panel();
      },
      cmdk: function() {
        self.open_search_panel();
      }
    };
  }

  key_press() {
    this.obj_actions();
    let self = this;
    $(document).on('keydown', function (e) {
      for(let key in self.actions) {
        let cmdk = (e.metaKey && e.code == 'KeyK') ? "cmdk" : "";
        if(cmdk === "cmdk") {
          return self.actions.cmdk();
        } else if(e.keyCode == key) {
          self.actions[e.keyCode]();
          return ;
        }
      }
    });
  }

  delete_attr_active() {
    $( "#search_query" ).focus(function() {
     $('#selected_search_result_item').removeAttr('id');
    });
  }

  auth_user() {
    $(document).keypress(function(e) {
      if($('#selected_search_result_item').length <= 0) return;
      if(e.which == 13) {
        $("#selected_search_result_item").find(".default-link")[1].click();
      }
    });
  }

  close_search_mouse() {
    let self = this;
    $(document).on('click', '.close-search', function () {
      self.remove_search_page();
    });
  }

  focus_on_el_search() {
    $(".result-item").first().attr("id", "selected_search_result_item");
    $("#selected_search_result_item").focus();
  }

  out_focus() {
    let self = this;
    $("#search_query").bind("focusout",function(){
      self.focus_on_el_search();
    });    
  }
  
  initialize_at_power_search() {
    this.focus_on_str_search();
    this.close_search_mouse();
  }

  initialize_search() {
    this.focus_on_el_search();
    this.delete_attr_active();
    this.out_focus();
    this.auth_user();
  }

  load() {
    this.delete_attr_active();
  }
}

export default AdminHotKey;

